export default {
  functional: true,
  props: {
    level: {
      type: Number,
      required: true
    }
  },
  render(h, context) {
    const tagName = `h${context.props.level}`

    return h(tagName, { class: 'headline' }, context.children)
  }
}
